import {
  ClickAwayListener,
  Grow,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Typography,
} from '@pickupp/ui/core'
import { makeStyles } from '@pickupp/ui/styles'
import React, { useEffect, useState } from 'react'

import { BROWSER } from '~/config'
import HKFlag from '~/src/assets/hk_flag.png'
import MYFlag from '~/src/assets/my_flag.png'
import SGFlag from '~/src/assets/sg_flag.png'
import TWFlag from '~/src/assets/tw_flag.png'

import styles from './styles'

const useStyles = makeStyles(styles)

const regionData = {
  hk: {
    label: 'Hong Kong',
    flag: HKFlag,
    url: 'https://hk.pickupp.io',
  },
  my: {
    label: 'Malaysia',
    flag: MYFlag,
    url: 'https://my.pickupp.io',
  },
  sg: {
    label: 'Singapore',
    flag: SGFlag,
    url: 'https://sg.pickupp.io',
  },
  tw: {
    label: 'Taiwan',
    flag: TWFlag,
    url: 'https://tw.pickupp.io',
  },
}

const RegionSwitcher = () => {
  const classes = useStyles()
  const [region, setRegion] = useState('hk')
  const [anchor, setAnchor] = useState(null)
  const [open, setOpen] = useState(false)

  const onOpen = (event) => {
    setAnchor(event.currentTarget)
    setOpen(true)
  }

  const onClose = (regionCode) => {
    setOpen(false)
    if (Object.keys(regionData).includes(regionCode) && BROWSER) {
      const { pathname } = window.location
      const destination = `${regionData[regionCode].url}${pathname}`
      window.location = destination
    }
  }

  useEffect(() => {
    if (BROWSER) {
      const currentRegion = window.location.host.split('.')[0]
      if (Object.keys(regionData).includes(currentRegion)) {
        setRegion(currentRegion)
      }
    }
  }, [])

  return (
    <div
      onClick={onOpen}
      className={classes.mainContainer}
    >
      <img
        src={regionData[region].flag}
        alt="Region"
        className={classes.icon}
      />
      <Typography>
        {regionData[region].label}
      </Typography>
      <Popper
        className={classes.regionPopup}
        open={open}
        anchorEl={anchor}
        placement="bottom-start"
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                  placement === 'bottom-start' ? 'left top' : 'left bottom',
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={onClose}>
                <MenuList
                  autoFocusItem={open}
                  id="composition-menu"
                  aria-labelledby="composition-button"
                >
                  {Object.keys(regionData).map((regionCode) => {
                    const item = regionData[regionCode]
                    return (
                      <MenuItem
                        key={regionCode}
                        disabled={regionCode === region}
                        onClick={() => onClose(regionCode)}
                      >
                        {item.label}
                      </MenuItem>
                    )
                  })}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
  )
}

export default RegionSwitcher
